import React,{useState, useEffect}  from 'react';
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card';
import Cppbar from '../Bars/Cppbar';

function Cgoto(){
return(
    <div >
    
    <h1>Goto in c</h1>
    <div className="first">
        <a href="/csharp-control-structure"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if-else"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

    <h2 className="mt-4 mh2">goto Statement in C++</h2>
<p className="mt-3 para">the goto keyword in c++ programming is used to transfer the program control from one location to another location.</p>


<Card border="primary m-4">
  <Card.Header as="h5">goto in c++ syntax:</Card.Header>
  <Card.Body>
    <Card.Text>
    |<br/>
|<br/>
table name:<br/>
|<br/>
|<br/>
|<br/>
Goto table name<br/>

    </Card.Text>
  </Card.Body>
  <Card.Footer>This is a comment  example in C</Card.Footer>
</Card>


<Card border="primary m-4">
  <Card.Header as="h5">Q-goto ques?</Card.Header>
  <Card.Body>
    <Card.Text>
    void main()<br/>
    &#123;<br/>
int a=1;<br/>
Message:<br/>
Printf(“%d”,&#38;a);<br/>
A--;<br/>
If(a>=0)<br/>
Goto message;<br/>
}<br/>


    </Card.Text>
  </Card.Body>
  <Card.Footer>This is a comment example in C</Card.Footer>
</Card>

<Card border="primary m-4">
  <Card.Header as="h5">Q-goto by usin if else?
</Card.Header>
  <Card.Body>
    <Card.Text>
    main( ) <br/>
    &#123;<br/>
 int  goals ; <br/>
 printf ( "Enter the  goals" ) ;<br/>
scanf ( "%d", &#38;goals ) ; <br/>
 if ( goals &#60;= 5 ) <br/>
  goto sos ; <br/>
 else <br/>
 &#123; <br/>
 printf ( "About time soccer players learnt C\n" );  <br/>
 printf ( "and said goodbye! adieu! to soccer" ) ; <br/>
  exit(  ) ; <br/>
 /* terminates program execution */ <br/>
  } <br/>
 sos : <br/> 
 printf ( "To err is human!" ) ; <br/>

    </Card.Text>
  </Card.Body>
  <Card.Footer>This is a comment  example in C</Card.Footer>
</Card>
<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/csharp-goto">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-oops">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
)

}
export default Cgoto;